import React, { useRef, useState } from 'react'
import { DeleteWorkStat, UpdateWorkStat } from './WorkStatCRUD';
import { WorkStatModal } from '../CustomFunctions';

const InputTypeBadge = ({ type }) => {
    if (!type) return <span>-</span>;
    
    const classMap = {
        Input:      "badge-input",
        Stage:      "badge-stage",
        Submission: "badge-submission",
    };

    return (
        <span className={`input-type-badge ${classMap[type] || "badge-default"}`}>
            {type}
        </span>
    );
};

const WorkStat = ({ getData, list, buffering }) => {
    const tableRef = useRef(null);
    const [selectedWorkStat, setSelectedWorkStat] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleViewDetails = (item) => {
        setSelectedWorkStat(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedWorkStat(null);
    };

    return (
        <div className='table-css-white-background' style={{ width: "100%" }}>
            <div className="table-box paddingTop-0px scroll-container-table" style={{ height: "70vh" }}>
                <table ref={tableRef} className="table-css" style={{ width: "100%" }}>
                    <thead className='table-heading'>
                        <tr className='custom-table-head-tr'>
                            <th className='table-heading-text text-start' style={{ width: "70px" }}>S.No.</th>
                            <th className='table-heading-text text-start'>Work Stage Name</th>
                            <th className='table-heading-text text-start' style={{ width: "150px" }}>Input Type</th>
                            <th className='table-heading-text text-end' style={{ width: "110px" }}>Action</th>
                        </tr>
                    </thead>
                    {buffering ? (
                        <tbody>
                            <tr>
                                <td colSpan={4}>
                                    <div className="spinner-bgdatil"></div>
                                </td>
                            </tr>
                        </tbody>
                    ) : (
                        <tbody>
                            {list
                                ?.sort((a, b) => a.name?.localeCompare(b.name))
                                .map((i, index) => (
                                    <tr key={i.id || index} className="custom-table-head-td">
                                        <td className="table-body text-start" style={{ width: "70px" }}>{index + 1}.</td>
                                        <td className="table-body text-start">
                                            <span className="font-size-text">{i.name || "-"}</span>
                                            <button
                                                className="view-details-btn"
                                                onClick={() => handleViewDetails(i)}
                                            >
                                                View More
                                            </button>
                                        </td>
                                        <td className="table-body text-start" style={{ width: "150px" }}>
                                            <InputTypeBadge type={i.workstage_inputtype} />
                                        </td>
                                        <td className="table-body text-end" style={{ width: "110px" }}>
                                            <UpdateWorkStat getData={getData} i={i} />
                                            <DeleteWorkStat getData={getData} i={i} />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    )}
                </table>
            </div>
            <WorkStatModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                data={selectedWorkStat}
                usedFor="workstat"
            />
        </div>
    );
}

export default WorkStat;